button{width:150px}
/*# sourceMappingURL=update-detect.component-IGTDYQLR.css.map */
